"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ParentNotFoundByUserIdError extends client_library_1.ExtendableError {
    constructor(userId) {
        super(`Parent with userId ${userId} not found`);
        this.userId = userId;
    }
}
exports.default = ParentNotFoundByUserIdError;
//# sourceMappingURL=ParentNotFoundByUserIdError.js.map